import React from 'react'
import { Box, Typography, Divider } from '@mui/material';
import SubTitleTemplate from '../../../components/common/template/SubTitleTemplate';
import TechMidTemplate from '../../../components/projectmng/support/TechMidTemplate';
import DetailTemplate from '../../../components/common/template/DetailTemplate';

const TechMidsViewContainer = ({ tech, techMids, user }) => {
    if (!techMids || techMids.length === 0) {
        return (
            <DetailTemplate title="진행기록 이력 리스트">
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Typography variant="subtitle2" component="div">등록된 진행기록이 없습니다.</Typography>
                </Box>
            </DetailTemplate>

        )
    }

    return (
        <DetailTemplate title={`진행기록 이력 리스트 (총 : ${techMids.length}건)`}>

            <Divider />
            {techMids.length > 0 && techMids.map((techMid, index) => {

                const title = techMids.length - index + ". [" + techMid.rptNo + "] " + techMid?.rptTitle;
                return (
                    <SubTitleTemplate title={title} id={index} sx={{ my: 1 }}>
                        <TechMidTemplate tech={tech} techMid={techMid} user={user} />
                    </SubTitleTemplate>
                )
            })}
        </DetailTemplate>
    )
}

export default TechMidsViewContainer
